// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"81":"css/index","165":"css/auth"}[chunkId] + ".css";
};